// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ActionCableVue from 'actioncable-vue'
import App from './App'
import router from './router'
import store from './store'
import i18n from './constants/lang/i18n'
import { Validator } from 'vee-validate'

import './constants/font/font.sass'

Validator.extend('youtubeLink', {
  getMessage: () => '',
  validate: value => /(?:src="|^)https:\/\/www\.youtube\.com\/embed\/([a-zA-Z0-9]+)(?="|$)/.test(value)
})

require('./plugins/validation')
require('./plugins/localstorage')

Vue.config.productionTip = false

Vue.component('item', {
  template: `
    <li>
      <div class="mask"></div>
      <div class="line-container">
        <div class="line"></div>
      </div>
      <div class="item-container row-block" :class="{ open: tree.type === 'folder' && open && !disabled, selected: selected && !disabled, disabled: disabled }" @click.stop="e => !disabled && toggle()">
        <div class="item-icon" v-if="tree.title">
          <img :src="tree.type === 'folder' ? open ? icons.open : icons.close : selected ? icons.select : icons.file" alt="">
        </div>
        <div :style="{ width: '5px' }"></div>
        <div class="item-title shrink">{{ tree.title }}</div>
        <div :style="{ flex: 1 }"></div>
        <img v-if="tree.type === 'file' && !disabled && options.checkbox !== false" class="item-check" :src="selected ? icons.boxtrue : icons.boxfalse">
      </div>
      <ul v-show="open" v-if="Object.keys(tree.nodes || {}).length > 0 && !disabled">
        <div class="line"></div>
        <item v-for="(node, title, index) in tree.nodes" :key="index" :tree="{ ...node, title: title }" :options="options" :icons="icons" :currentPath="currentPath" :selectedPaths="selectedPaths" :disabledPaths="disabledPaths" @select="path => $emit('select', path)">
        </item>
      </ul>
    </li>
  `,
  props: {
    tree: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    icons: {
      type: Object,
      required: true
    },
    currentPath: {
      type: Array,
      required: true
    },
    selectedPaths: {
      type: Array,
      required: true
    },
    disabledPaths: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      open: this.currentPath.includes(this.tree.title) || !this.tree.title
    }
  },
  computed: {
    selected () {
      return this.selectedPaths.includes(this.tree.path)
    },
    disabled () {
      return this.disabledPaths.includes(this.tree.path)
    }
  },
  methods: {
    toggle () {
      switch (this.tree.type) {
        case 'folder': {
          if (this.tree.title) {
            this.open = !this.open
          }
          break
        }
        case 'file': {
          if (this.tree.title) {
            this.$emit('select', this.tree.path)
          }
        }
      }
    }
  }
})

Vue.component('treeList', {
  template: `
    <ul id="root" :class="{ 'no-root': !treeData.title }">
      <item :tree="treeData" :options="options" :icons="icons" :currentPath="(currentPath || '').split('/')" :selectedPaths="selectedPaths" :disabledPaths="disabledPaths" @select="path => $emit('select', path)"></item>
    </ul>
  `,
  props: {
    treeData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    },
    icons: {
      type: Object,
      required: true
    },
    currentPath: {
      type: String,
      default: () => ''
    },
    selectedPaths: {
      type: Array,
      required: true
    },
    disabledPaths: {
      type: Array,
      required: true
    }
  }
})

Vue.component('familyPedigree', {
  template: `
    <div
      class="family-pedigree-main-field col-block stretch"
      :style="{
        width: pedigreeDatas.nodeLength ? (pedigreeDatas.nodeLength * 120 - 20 + 'px') : 'auto',
        gap: '20px'
      }"
    >
      <div
        v-if="hasParent"
        class="family-pedigree-parent-container row-block stretch"
        :class="{ hidden: hiddenParent }"
        :style="{ gap: '20px' }"
      >
        <familyPedigree
          :pedigreeDatas="pedigreeDatas.fathers"
          :depth="depth + 1"
          :position="'left'"
        ></familyPedigree>
        <familyPedigree
          :pedigreeDatas="pedigreeDatas.mothers"
          :depth="depth + 1"
          :position="'right'"
        ></familyPedigree>
      </div>
      <div class="family-pedigree-main-container row-block stretch">
        <div class="family-pedigree-parent-line-container col-block" :style="{ flex: 1, width: 0, height: 'calc(100% + 20px - 2.9px)' }">
          <div
            v-if="position === 'right'"
            class="family-pedigree-parent-line-block main-line-container"
            :style="{
              flex: 1,
              width: 'calc(100% + 10px + 50px)',
              marginRight: '-50px',
              marginLeft: '-10px'
            }"
          >
            <svg width="100%" height="100%">
              <line
                x1="0%"
                y1="40px"
                x2="100%"
                y2="40px"
              />
              <line
                x1="0%"
                y1="40px"
                x2="0%"
                y2="100%"
              />
            </svg>
          </div>
        </div>
        <div class="family-pedigree-main-block col-block stretch">
          <div
            class="family-pedigree-sibling-line-container main-line-container"
            :style="{
              height: '20px'
            }"
          >
            <svg width="100%" height="20">
              <line
                x1="75px"
                y1="0"
                x2="50%"
                y2="0"
              />
            </svg>
            <svg width="100%" height="20" :style="{ transform: 'rotate(180deg)' }">
              <line
                x1="75px"
                y1="100%"
                x2="50%"
                y2="100%"
              />
            </svg>
          </div>
          <div
            class="family-pedigree-sibling-node-list-container row-block flex-start"
            :style="{
              gap: '20px'
            }"
          >
            <div
              class="family-pedigree-sibling-node-container col-block stretch"
              v-for="(node, index) in pedigreeDatas.nodes"
              :key="index"
              :class="{ empty: !node.title, affected: node.affected, proband: node.relation === 'Proband' }"
              :style="{
                width: '150px'
              }"
            >
              <div
                class="family-pedigree-sibling-node-line-container main-line-container"
                :style="{
                  height: '20px'
                }"
              >
                <svg v-if="(hasParent && !hiddenParent) || (nodeLength > 1)" width="100%" height="20">
                  <line
                    class="cover"
                    x1="50%"
                    y1="0%"
                    x2="50%"
                    y2="100%"
                  />
                </svg>
              </div>
              <div class="family-pedigree-sibling-node-main-container row-block">
                <div class="family-pedigree-sibling-node-main-sub-container col-block" :style="{ flex: 1 }">
                  <div :style="{ flex: 1 }"></div>
                  <div class="family-pedigree-sibling-node-main-proband-container row-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="family-pedigree-sibling-node-main-proband-icon"></div>
                    <div :style="{ width: '10px' }"></div>
                  </div>
                  <div :style="{ flex: 1 }"></div>
                </div>
                <div class="family-pedigree-sibling-node-main-block">
                  <svg width="50" height="50">
                    <component
                      :is="{ 'Male': 'rect', 'Female': 'circle' }[node.sex] || 'rect'"
                      x="1"
                      y="1"
                      width="47"
                      height="47"
                      cx="25"
                      cy="25"
                      r="23"
                      :style="{ 'stroke-width': ['Male', 'Female'].includes(node.sex) ? '3px' : '4px' }"
                      :transform="!['Male', 'Female'].includes(node.sex) ? 'translate(25, 0) scale(0.72) rotate(45)' : null"
                    />
                  </svg>
                </div>
                <div class="family-pedigree-sibling-node-main-sub-container col-block" :style="{ flex: 1 }"></div>
              </div>
              <div :style="{ height: '5px' }"></div>
              <div class="family-pedigree-sibling-node-text-container col-block width-full">
                <div class="family-pedigree-sibling-node-title-container ellipsis" :title="node.title" v-html="node.title || 'N/A'"></div>
                <div class="family-pedigree-sibling-node-ra-container ellipsis" :class="{ empty: !node.RefAlt }" :title="node.RefAlt" v-html="node.RefAlt || '-'"></div>
                <div class="family-pedigree-sibling-node-gt-container ellipsis" :class="{ empty: !node.GT }" :title="node.GT" v-html="node.GT || '-'"></div>
                <div class="family-pedigree-sibling-node-qc-list-container row-block flex-wrap" :class="{ empty: !(node.QC || []).length }">
                  <div class="family-pedigree-sibling-node-qc-container" v-for="(qc, qcIndex) in (node.QC || [])" :key="qcIndex" :title="qc" v-html="qc || '-'"></div>
                </div>
              </div>
            </div>
          </div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div class="family-pedigree-parent-line-container col-block" :style="{ flex: 1, width: 0, height: 'calc(100% + 20px - 2.9px)' }">
          <div
            v-if="position === 'left'"
            class="family-pedigree-parent-line-block main-line-container"
            :style="{
              flex: 1,
              width: 'calc(100% + 10px + 50px)',
              marginLeft: '-50px',
              marginRight: '-10px'
            }"
          >
            <svg width="100%" height="100%">
              <line
                x1="0%"
                y1="40px"
                x2="100%"
                y2="40px"
              />
              <line
                x1="100%"
                y1="40px"
                x2="100%"
                y2="100%"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  `,
  props: {
    pedigreeDatas: {
      type: Object,
      required: true
    },
    depth: {
      type: Number,
      default: () => 0
    },
    position: {
      type: String,
      default: () => 'center'
    }
  },
  computed: {
    hasParent () {
      return this.pedigreeDatas.hasParent
    },
    hiddenParent () {
      return this.pedigreeDatas.hiddenParent
    },
    nodeLength () {
      return (this.pedigreeDatas.nodes || []).length
    }
  }
})

Vue.use(ActionCableVue, {
  connectImmediately: false
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js